import { TABLE_SECTIONS } from "../model/administrationConstants";
import { groupHeaderStyle, inputStyle, subHeaderStyle } from "./administrationStyles";

export const identityModalActionsStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap",
    paddingTop: "4px",
};

export const deletePatientButtonStyle = {
    border: "1px solid #dc2626",
    borderRadius: "7px",
    padding: "8px 12px",
    background: "white",
    color: "#b91c1c",
    cursor: "pointer",
    fontWeight: 700,
};

export const confirmDeleteButtonStyle = {
    border: 0,
    borderRadius: "7px",
    padding: "9px 13px",
    background: "#dc2626",
    color: "white",
    cursor: "pointer",
    fontWeight: 700,
};

export const iconButtonStyle = {
    width: "32px", height: "32px", border: "1px solid #d1d5db", borderRadius: "6px",
    background: "white", color: "#374151", cursor: "pointer", fontSize: "20px", lineHeight: 1,
};

export const stickyActionsHeaderStyle = { right: 0, zIndex: 6, minWidth: "135px" };

export const stickyActionsCellStyle = { position: "sticky", right: 0, zIndex: 2, background: "inherit", minWidth: "135px" };

export const cellStyle = { verticalAlign: "top", padding: "9px", borderRight: "1px solid #e5e7eb", borderBottom: "1px solid #e5e7eb", minWidth: "145px", maxWidth: "240px", overflowWrap: "anywhere" };

export const groupHeaderStyleFor = section => ({
    ...groupHeaderStyle,
    background: TABLE_SECTIONS[section]?.header || groupHeaderStyle.background,
    borderRight: `1px solid ${TABLE_SECTIONS[section]?.border || "#475569"}`,
    borderBottom: `1px solid ${TABLE_SECTIONS[section]?.border || "#475569"}`,
});

export const subHeaderStyleFor = section => ({
    ...subHeaderStyle,
    background: TABLE_SECTIONS[section]?.subHeader || subHeaderStyle.background,
    color: "#111827",
    borderRight: `1px solid ${TABLE_SECTIONS[section]?.border || "#475569"}`,
    borderBottom: `1px solid ${TABLE_SECTIONS[section]?.border || "#475569"}`,
});

export const sectionCellStyle = (section, dirty = false) => ({
    ...cellStyle,
    background: dirty ? "#eef2ff" : (TABLE_SECTIONS[section]?.cell || "white"),
    borderRight: `1px solid ${TABLE_SECTIONS[section]?.border || "#e5e7eb"}`,
});

export const emptyCellStyle = { padding: "32px", textAlign: "center", color: "#9ca3af" };

export const primaryButtonStyle = { border: 0, borderRadius: "6px", padding: "8px 12px", background: "#4f46e5", color: "white", fontWeight: 600, cursor: "pointer", whiteSpace: "nowrap" };

export const secondaryButtonStyle = { border: "1px solid #d1d5db", borderRadius: "6px", padding: "7px 11px", background: "white", color: "#374151", cursor: "pointer", whiteSpace: "nowrap" };

export const dangerButtonStyle = { ...secondaryButtonStyle, color: "#b91c1c", borderColor: "#fecaca" };

export const disabledPrimaryButtonStyle = { ...primaryButtonStyle, background: "#c7d2fe", cursor: "not-allowed", opacity: 0.8 };

export const eventButtonStyle = { display: "grid", gap: "3px", width: "100%", padding: "8px", textAlign: "left", border: "1px solid #c7d2fe", borderRadius: "7px", background: "#eef2ff", cursor: "pointer", color: "#111827" };

export const chronicBillingCellStyle = { display: "grid", gap: "8px", minWidth: "180px" };

export const chronicBillingHeaderStyle = { display: "flex", justifyContent: "flex-end" };

export const chronicBillingActionsStyle = { display: "flex", flexWrap: "wrap", gap: "7px" };

export const chronicHistoryButtonStyle = {
    ...secondaryButtonStyle,
    background: "#eef2ff",
    borderColor: "#c7d2fe",
    color: "#3730a3",
    fontWeight: 800,
};

export const chronicBillingEmptyStyle = { color: "#64748b", fontSize: "12px", padding: "4px 0" };

export const chronicBillingRowsStyle = { display: "grid", gap: "7px" };

export const chronicBillingRowStyle = hovered => ({
    display: "grid",
    gridTemplateColumns: "minmax(260px, 2fr) minmax(150px, 0.9fr) minmax(240px, 2fr)",
    gap: "10px",
    alignItems: "start",
    padding: "8px",
    border: "1px solid #c7d2fe",
    borderRadius: "7px",
    background: hovered ? "#eef2ff" : "white",
});

export const chronicRowActionsStyle = {
    gridColumn: "1 / -1",
    display: "flex",
    justifyContent: "flex-end",
    gap: "7px",
};

export const chronicBillingProductStyle = {
    display: "grid",
    gap: "6px",
    minWidth: 0,
    color: "#1e293b",
    fontSize: "12px",
    lineHeight: 1.3,
};

export const chronicAddedMetaStyle = {
    color: "#64748b",
    fontSize: "11px",
    lineHeight: 1.25,
};

export const chronicDirectReasonFieldStyle = {
    display: "grid",
    gap: "4px",
    color: "#64748b",
    fontSize: "10px",
    fontWeight: 800,
};

export const chronicProductCommentFieldStyle = {
    display: "grid",
    gap: "4px",
    color: "#64748b",
    fontSize: "10px",
    fontWeight: 800,
};

export const chronicProductCommentTextareaStyle = {
    ...inputStyle,
    minHeight: "58px",
    resize: "vertical",
    lineHeight: 1.35,
    width: "100%",
};

export const chronicMarkBilledButtonStyle = {
    border: "1px solid #bbf7d0",
    borderRadius: "6px",
    padding: "5px 7px",
    background: "#f0fdf4",
    color: "#166534",
    cursor: "pointer",
    fontSize: "11px",
    fontWeight: 800,
};

export const chronicRemoveHistoryButtonStyle = {
    border: "1px solid #fecaca",
    borderRadius: "6px",
    padding: "6px 9px",
    background: "#fff1f2",
    color: "#b91c1c",
    cursor: "pointer",
    fontSize: "11px",
    fontWeight: 800,
    whiteSpace: "nowrap",
};

export const chronicInlineErrorStyle = { color: "#b91c1c", fontSize: "12px", lineHeight: 1.35 };

export const chronicManualProductFormStyle = {
    display: "grid",
    gridTemplateColumns: "minmax(240px, 1.5fr) minmax(110px, 0.7fr) minmax(170px, 1fr) auto",
    gap: "10px",
    alignItems: "end",
    padding: "12px",
    marginBottom: "14px",
    border: "1px solid #c7d2fe",
    borderRadius: "8px",
    background: "#eef2ff",
};

export const chronicProductListStyle = { display: "grid", gap: "12px", maxHeight: "520px", overflowY: "auto", paddingRight: "4px" };

export const chronicProductGroupStyle = { border: "1px solid #e0e7ff", borderRadius: "8px", background: "#f8fafc", padding: "10px" };

export const chronicProductGroupHeaderStyle = { display: "flex", justifyContent: "space-between", gap: "10px", alignItems: "center", color: "#312e81", fontSize: "13px", marginBottom: "9px" };

export const chronicProductRowStyle = (selected, disabled = false) => ({
    width: "100%",
    border: "1px solid #e5e7eb",
    borderRadius: "7px",
    background: disabled ? "#f8fafc" : selected ? "#e0e7ff" : "white",
    color: disabled ? "#94a3b8" : "#111827",
    padding: "10px 12px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "12px",
    textAlign: "left",
    cursor: disabled ? "not-allowed" : "pointer",
    opacity: disabled ? 0.72 : 1,
});

export const chronicProductMetaStyle = { display: "block", color: "#64748b", fontSize: "12px", marginTop: "3px" };

export const billingValidationBadgeStyle = (validated, alreadyInHistory = false) => ({
    flex: "0 0 auto",
    borderRadius: alreadyInHistory ? "6px" : "999px",
    padding: "4px 8px",
    background: alreadyInHistory ? "#e2e8f0" : validated ? "#dcfce7" : "#fee2e2",
    color: alreadyInHistory ? "#475569" : validated ? "#166534" : "#991b1b",
    fontSize: "11px",
    fontWeight: 700,
});

export const chronicHistoryProductInfoStyle = {
    marginTop: "4px",
    color: "#334155",
    fontSize: "13px",
    lineHeight: 1.4,
    overflowWrap: "anywhere",
};

export const chronicHistoryCommentStyle = {
    display: "block",
    marginTop: "4px",
    color: "#64748b",
    fontSize: "12px",
    lineHeight: 1.35,
    overflowWrap: "anywhere",
};

export const chronicHistoryActionsStyle = {
    display: "grid",
    gridTemplateColumns: "minmax(140px, 180px) minmax(140px, 170px) minmax(180px, 1fr) auto",
    gap: "10px",
    alignItems: "end",
};

export const chronicReasonFieldStyle = {
    display: "grid",
    gap: "4px",
    color: "#64748b",
    fontSize: "11px",
    fontWeight: 800,
};

export const chronicCommentFieldStyle = {
    display: "grid",
    gap: "4px",
    color: "#64748b",
    fontSize: "11px",
    fontWeight: 800,
};

export const modalFooterStyle = { display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "18px" };

export const backdropStyle = { position: "fixed", inset: 0, zIndex: 1000, background: "rgba(15, 23, 42, 0.55)", display: "flex", alignItems: "center", justifyContent: "center", padding: "20px" };

export const modalStyle = { maxWidth: "calc(100vw - 40px)", maxHeight: "calc(100vh - 40px)", overflow: "auto", background: "white", borderRadius: "12px", boxShadow: "0 20px 50px rgba(0,0,0,.25)", padding: "20px" };

export const modalHeaderStyle = { display: "flex", justifyContent: "space-between", alignItems: "center", gap: "16px", marginBottom: "20px" };

export const closeButtonStyle = { border: 0, background: "transparent", fontSize: "28px", cursor: "pointer", color: "#6b7280" };

export const pdaRemarkWithHistoryStyle = { display: "grid", gap: "8px" };

export const pdaHistoryPanelStyle = { display: "grid", gap: "7px", padding: "9px", borderRadius: "7px", border: "1px solid #bfdbfe", background: "#eff6ff" };

export const pdaHistoryTitleStyle = { color: "#1d4ed8", fontSize: "12px", fontWeight: 900 };

export const pdaHistoryItemStyle = { padding: "7px 0", borderTop: "1px solid #dbeafe" };

export const pdaHistoryCommentStyle = { color: "#1e3a8a", fontSize: "12px", fontWeight: 800, lineHeight: 1.35, overflowWrap: "anywhere" };

export const pdaHistoryMetaStyle = { marginTop: "3px", color: "#64748b", fontSize: "11px", fontWeight: 700 };

export const pdaHistoryEmptyStyle = { padding: "8px 9px", borderRadius: "7px", border: "1px dashed #bfdbfe", background: "#f8fafc", color: "#64748b", fontSize: "12px", fontWeight: 700 };

export const pdaHistoryButtonStyle = { ...secondaryButtonStyle, width: "fit-content", padding: "5px 8px", fontSize: "12px" };

export const pdaHistoryActionsStyle = { display: "flex", flexWrap: "wrap", gap: "8px" };

export const historyRowStyle = { display: "flex", justifyContent: "space-between", gap: "20px", padding: "12px 4px", borderBottom: "1px solid #e5e7eb" };

export const emptyStyle = { color: "#9ca3af", textAlign: "center", padding: "20px" };

export const errorStyle = { color: "#b91c1c", background: "#fef2f2", border: "1px solid #fecaca", borderRadius: "7px", padding: "10px 12px" };

export const centeredStyle = { padding: "60px 32px", maxWidth: "600px", margin: "0 auto", textAlign: "center", color: "#374151" };

export const proposalPanelStyle = {
    display: "grid",
    gap: "12px",
    background: "#fff7ed",
    border: "1px solid #fed7aa",
    borderRadius: "10px",
    padding: "14px",
    marginBottom: "16px",
};

export const proposalHeaderStyle = { display: "flex", justifyContent: "space-between", gap: "12px", alignItems: "flex-start" };

export const proposalCountStyle = {
    minWidth: "28px",
    height: "28px",
    borderRadius: "999px",
    background: "#c2410c",
    color: "white",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 900,
};

export const proposalCardStyle = {
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr) auto",
    gap: "12px",
    alignItems: "center",
    background: "white",
    border: "1px solid #fdba74",
    borderRadius: "8px",
    padding: "12px",
};

export const proposalMetaStyle = {
    display: "inline-flex",
    borderRadius: "999px",
    background: "#ffedd5",
    color: "#9a3412",
    padding: "3px 8px",
    fontSize: "12px",
    fontWeight: 800,
};

export const proposalValuesStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
    gap: "8px",
    marginTop: "9px",
    color: "#334155",
    fontSize: "13px",
    overflowWrap: "anywhere",
};

export const proposalActionsStyle = { display: "flex", gap: "8px", flexWrap: "wrap", justifyContent: "flex-end" };
